import React, { useEffect, useState, useRef } from "react";

import CountUp from 'react-countup';
import classes  from './styles.module.scss';

export default function StatsHighlight({statistics}) {

    const countUpRef = useRef(null);
    const [countingStarted, setCountingStarted] = useState(false);

    useEffect(() => {
        const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.5,
        };

        const observer = new IntersectionObserver(handleIntersection, options);
        observer.observe(countUpRef.current);

        return () => {
        observer.disconnect();
        };
    }, []);

    const handleIntersection = (entries) => {
        entries.forEach((entry) => {
        if (entry.isIntersecting) {
            setCountingStarted(true);
        }
        });
    };

    function getVariantClass(input) {
        switch(input) {
            case "primary":
                return classes.primary;
            case "secondary":
                return classes.secondary;
            case "tertiary":
                return classes.tertiary;
            case "quaternary":
                return classes.quaternary;
            default:
                return classes.primary;
        }
    }

    return (
        <section id="StatsHighlight" className={`${classes.stats_highlight}`}>
            <div ref={countUpRef} className={classes.stats_card}>
                {countingStarted && statistics.map((stat, index) => (
                    <div key={index} className={`${classes.stats} ${getVariantClass(stat.variant)}`}>
                        <div className={classes.value}><CountUp end={stat.value} decimals={stat.value % 1 === 0 ? 0 : 1} duration={2}/>{stat.suffix}</div>
                        <div className={`font-regular ${classes.description}`}>{stat.description}</div>
                    </div>
                ))}
            </div>
        </section>
    )}